<template>
  <section id="contents" class="page_account">
  	<div id="title_block">
  		<h1 class="title_text">パスワード再発行</h1>
  		<p class="btn_back"><a href="javascript:history.back();">戻る</a></p>
  	</div>
    <div class="contents_inner">
      <form @submit.prevent="confirmPassword">
        <div class="form_box">
          <table>
            <tr>
              <th>メールアドレス</th>
              <td>
                <p><input type="text" placeholder="" v-model="username" required></p>
              </td>
            </tr>
            <tr>
              <th>再設定コード</th>
              <td>
                <p><input type="text" placeholder="" v-model="verificationCode" required></p>
              </td>
            </tr>
            <tr>
              <th>パスワード</th>
              <td>
                <p><input type="password" placeholder="" v-model="password" required></p>
                <p><input type="password" placeholder="確認用" v-model="passwordConfirm" required></p>
              </td>
            </tr>
          </table>
        </div>
        <p class="submit"><button>再設定</button></p>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ConfirmPassword',
  data () {
    return {
      username: '',
      verificationCode: '',
      password: '',
      passwordConfirm: ''
    }
  },
  methods: {
    confirmPassword () {
      if (this.username && (this.password === this.passwordConfirm)) {
        this.$cognito.confirmPassword(this.username, this.verificationCode, this.password)
          .then(result => {
            this.$notify({ group: 'main', text: 'パスワードを更新しました。' })
            this.$router.replace('/login')
          })
          .catch(err => {
            this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.confirm-password." + err.code) })
          })
      } else {
        this.$notify({ group: 'main', type: 'error', text: 'パスワードとパスワード（確認用）が異なります' })
      }
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/ConfirmPassword.vue